import React, { useState } from "react";
import "./GDLab.css";
import app_logo from '../../static/img/app_logo.png';
import app_screen_1 from '../../static/img/dentapp.jpg';
import app_screen_2 from '../../static/img/dentapp (1).jpg';
import app_screen_3 from '../../static/img/dentapp (2).jpg';
import app_screen_4 from '../../static/img/dentapp (3).jpg';
import app_screen_5 from '../../static/img/dentapp (4).jpg';
import app_screen_6 from '../../static/img/dentapp (5).jpg';

import emblem from '../../static/img/header_logo_2.png';


import app_title from '../../static/img/title.png';
import { appstore_svg, email_svg, googleplay_svg, insta_svg, location_svg, phone_svg, rustore_svg, school_svg, vk_svg, youtube_svg } from "../Svg/svgs";
import CarouselSection from "../MainBlock/Carousel";
import BuyButton from "../DentAppBlock/BuyButton";

import PriceList from "../Price/PriceList";
import Modal from '../Price/modal'
import Photos from "../Photos/Photos";
import Requisites from "../Requisites/Requisites";
import Products from "../Products/Products";

const GDLab = () => {
    const [showMap, setShowMap] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showModalPhoto, setShowModalPhoto] = useState(false);
    const [showModalInfo, setShowModalInfo] = useState(false);
    const [showModalProducts, setShowModalProducts] = useState(false);

    return (
        <>
            <Modal showModal={showModal} setShowModal={setShowModal}>
                <h2>Прайс-лист</h2>
                <PriceList />
            </Modal>
            <Modal showModal={showModalPhoto} setShowModal={setShowModalPhoto}>
                <h2>Фотографии</h2>
                <Photos />
            </Modal>
            <Modal showModal={showModalInfo} setShowModal={setShowModalInfo}>
                {/* <h2>Реквизиты</h2> */}
                <Requisites/>
            </Modal>
            <Modal showModal={showModalProducts} setShowModal={setShowModalProducts}>
                <h2>Товары</h2>
                <Products/>
            </Modal>

            <div className="gd-lab-container">
                <img className="emblem" src={emblem} alt="emblem" />
                <div className="cntr_title_app">

                    <img src={app_title} alt="GD LAB" />
                </div>
                <h2 className="subtitle">Зуботехническая лаборатория<span className="year"> c 1992 года</span></h2>

                <div className="content_gd desk">
                    <div className="block_gd">
                        <div className="info-item">
                            {vk_svg}
                            <a href="https://vk.com/gd23_ru" target="_blank" rel="noopener noreferrer">Медиа портал</a>
                        </div>
                        <div className="info-item">
                            {school_svg}
                            <a href="https://gd-lab.zenclass.ru/public/school" target="_blank" rel="noopener noreferrer">Школа зубных техников</a>
                        </div>

                        <div className="info-item">
                            {email_svg}
                            <a href="mailto:gd23.ru@mail.ru">gd23.ru@mail.ru</a>
                        </div>
                        <div className="info-item">
                            {youtube_svg}
                            <a href="https://www.youtube.com/@gdlab8169/" target="_blank" rel="noopener noreferrer">YouTube</a>
                        </div>
                        <div className="info-item">
                            {insta_svg}
                            <a href="https://www.instagram.com/gd23.ru/" target="_blank" rel="noopener noreferrer">gd23.ru</a>
                        </div>
                        <div className="info-item">
                            {phone_svg}
                            <a href="tel:+79184339086">+7 918 433 90 86</a>
                        </div>
                        <div className="info-item">
                            {location_svg}
                            <label onClick={() => setShowMap(!showMap)}>г. Краснодар, ул. Воронежская, д. 3</label>
                        </div>
                        {showMap && <div className="map">[Карта с адресом]</div>}
                        <div className="line_gd"></div>
                        <CarouselSection />
                        <p className="info-text">
                            - Зуботехническая лаборатория «Глобал Дент» — первая лицензированная лаборатория в Краснодарском крае с 2000 года.<br />
                            - Заключаем официальные договоры с клиниками (для лицензирования).<br />
                            - Выполняем все виды работ на собственном оборудовании.<br />
                            - Доставка курьерами по городу Краснодару и Краснодарскому краю бесплатно.<br />
                            - Предлагаем индивидуальное обучение и повышение квалификации зубных техников с выдачей сертификатов.
                        </p>
                    </div>

                    <div className="block_gd_2">
                        
                        <div className="app-button">
                            <img src={app_logo} alt="DentApp" />
                            {/* <img src={app_screen_1} alt="DentApp" />
                        <img src={app_screen_1} alt="DentApp" />
                        <img src={app_screen_1} alt="DentApp" /> */}
                            <div class="image-container">
                                <img src={app_screen_1} alt="DentApp" />
                                <img src={app_screen_2} alt="DentApp" />
                                <img src={app_screen_3} alt="DentApp" />
                                <img src={app_screen_4} alt="DentApp" />
                                <img src={app_screen_5} alt="DentApp" />
                                <img src={app_screen_6} alt="DentApp" />
                            </div>
                        </div>
                        <label>Dent-App</label>
                        <label>ЛУЧшая программа для учета и контроля</label>
                        <div className="cntr_app_option">
                            {appstore_svg}
                            {googleplay_svg}
                            {rustore_svg}
                            <div className="cntr_buy_btn">
                                <BuyButton />
                            </div>
                        </div>
                        <button className="btn_gd" onClick={() => setShowModalPhoto(true)}>Фотографии</button>
                        <button className="btn_gd" onClick={() => setShowModal(true)}>Расценки</button>
                        <button className="btn_gd" onClick={() => setShowModalInfo(true)}>Реквизиты</button>
                        <button className="btn_gd" onClick={() => setShowModalProducts(true)}>Товары</button>
                    </div>
                </div>

                <div className="content_gd mob">
                    <div className="block_gd">
                        <div className="info-item">
                            {vk_svg}
                            <a href="https://vk.com/gd23_ru" target="_blank" rel="noopener noreferrer">Медиа портал</a>
                        </div>
                        <div className="info-item">
                            {school_svg}
                            <a href="https://gd-lab.zenclass.ru/public/school" target="_blank" rel="noopener noreferrer">Школа зубных техников</a>
                        </div>

                        <div className="info-item">
                            {email_svg}
                            <a href="mailto:gd23.ru@mail.ru">gd23.ru@mail.ru</a>
                        </div>
                        <div className="info-item">
                            {youtube_svg}
                            <a href="https://www.youtube.com/@gdlab8169/" target="_blank" rel="noopener noreferrer">YouTube</a>
                        </div>
                        <div className="info-item">
                            {insta_svg}
                            <a href="https://www.instagram.com/gd23.ru/" target="_blank" rel="noopener noreferrer">gd23.ru</a>
                        </div>
                        <div className="info-item">
                            {phone_svg}
                            <a href="tel:+79184339086">+7 918 433 90 86</a>
                        </div>
                        <div className="info-item">
                            {location_svg}
                            <label onClick={() => setShowMap(!showMap)}>г. Краснодар, ул. Воронежская, д. 3</label>
                        </div>
                        {showMap && <div className="map">[Карта с адресом]</div>}
                        <div className="line_gd"></div>
                        {/* todo */}
                        <label>Dent-App</label>
                        <label>ЛУЧшая программа для учета и контроля</label>
                        <div className="cntr_app_option">
                            {appstore_svg}
                            {googleplay_svg}
                            {rustore_svg}
                            <div className="cntr_buy_btn">
                                <BuyButton />
                            </div>
                        </div>
                    </div>

                    <div className="block_gd_2">
                        
                        <div className="app-button">
                            <img src={app_logo} alt="DentApp" />
                            {/* <img src={app_screen_1} alt="DentApp" />
                        <img src={app_screen_1} alt="DentApp" />
                        <img src={app_screen_1} alt="DentApp" /> */}
                            <div class="image-container">
                                <img src={app_screen_1} alt="DentApp" />
                                <img src={app_screen_2} alt="DentApp" />
                                <img src={app_screen_3} alt="DentApp" />
                                <img src={app_screen_4} alt="DentApp" />
                                <img src={app_screen_5} alt="DentApp" />
                                <img src={app_screen_6} alt="DentApp" />
                            </div>
                        </div>
                        <CarouselSection />
                        <p className="info-text">
                            - Зуботехническая лаборатория «Глобал Дент» — первая лицензированная лаборатория в Краснодарском крае с 2000 года.<br />
                            - Заключаем официальные договоры с клиниками (для лицензирования).<br />
                            - Выполняем все виды работ на собственном оборудовании.<br />
                            - Доставка курьерами по городу Краснодару и Краснодарскому краю бесплатно.<br />
                            - Предлагаем индивидуальное обучение и повышение квалификации зубных техников с выдачей сертификатов.
                        </p>
                        
                        <button className="btn_gd" onClick={() => setShowModalPhoto(true)}>Фотографии</button>
                        <button className="btn_gd" onClick={() => setShowModal(true)}>Расценки</button>
                        <button className="btn_gd" onClick={() => setShowModalInfo(true)}>Реквизиты</button>
                        <button className="btn_gd" onClick={() => setShowModalProducts(true)}>Товары</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default GDLab;
